// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"696":"fdf3e763","721":"fdf3e763","977":"fdf3e763"}[chunkId] + ".chunk.css";
};